import React, { useState, useRef, useEffect } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
interface Action {
  label: string;
  onClick: () => void;
  visible?: boolean;
}

interface ActionDropdownProps {
  actions: Action[];
}

const ActionDropdown: React.FC<ActionDropdownProps> = ({ actions }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const visibleActions = actions.filter((action) => action.visible !== false);

  const handleActionClick = (action: () => void) => {
    action();
    setIsOpen(false); // Close dropdown after clicking
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node;
      if (
        dropdownRef.current &&
        !(dropdownRef.current as HTMLElement).contains(target)
      ) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setIsOpen]);

  if (visibleActions.length === 0) {
    return null;
  }

  return (
    <div className="action-dropdown">
      <button
        className="action-dropdown__button"
        onClick={() => setIsOpen(!isOpen)}
      >
        Actions{" "}
        <MdKeyboardArrowDown
          size={20}
          className="action-dropdown__button-icon"
        />
      </button>

      {isOpen && (
        <div ref={dropdownRef} className="action-dropdown__menu">
          {visibleActions.map((action, index) => (
            <button
              key={index}
              onClick={() => handleActionClick(action.onClick)}
            >
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActionDropdown;
